// Tekster for pipelinen (pipeline v2.1): status på muligheter (Vunnet, Tapt,
// Gjenåpne) og innstillingene for stadiene. Egen fil så pakkene i
// spesifikasjonen kan legge til tekster uten å røre de store katalogene.
export const norwegianPipelineMessages = {
  crm: {
    deals: {
      probability_help: "Prosent. Tom bruker stadiets.",
      probability_overridden: "overstyrt",
      probability_range: "Sannsynligheten må være mellom 0 og 100",
      status: {
        open: "Åpen",
        won: "Vunnet",
        lost: "Tapt",
        disqualified: "Diskvalifisert",
        tabs: "Status",
        tab_open: "Åpne",
        tab_won: "Vunnet",
        tab_lost: "Tapt",
        empty_open: "Ingen åpne muligheter.",
        empty_won: "Ingen vunne muligheter ennå.",
        empty_lost: "Ingen tapte muligheter.",
        from_stage: "fra %{stage}",
        mark_won: "Merk som vunnet",
        mark_lost: "Merk som tapt",
        won_action: "Vunnet",
        lost_action: "Tapt",
        reopen: "Gjenåpne",
        won_done: "%{name} er merket som vunnet",
        lost_done: "%{name} er merket som tapt",
        reopened: "%{name} er gjenåpnet",
      },
    },
    settings: {
      pipeline: {
        title: "Pipeline",
        help: "Stadiene en åpen mulighet går gjennom. Vunnet, Tapt og Diskvalifisert er status, ikke stadier. Sannsynligheten brukes i vektet pipelineverdi, og råtning sier hvor mange virkedager uten aktivitet før en mulighet regnes som råtten.",
        label: "Navn",
        probability: "Sannsynlighet (%)",
        rot: "Råtner etter (virkedager)",
        inbox: "Innboks for nye leads",
        move_up: "Flytt opp",
        move_down: "Flytt ned",
        remove: "Fjern stadium",
        in_use: "Åpne muligheter står i dette stadiet",
        required_fields: "Påkrevd før en mulighet flyttes hit",
        next_step: "Foreslått neste steg",
        next_step_type: "Type",
        offset: "Frist (virkedager)",
        add: "Legg til stadium",
        save: "Lagre stadiene",
        saved: "Stadiene er lagret",
        save_error: "Stadiene kunne ikke lagres",
        need_one: "Pipelinen må ha minst ett stadium.",
        need_label: "Alle stadier må ha et navn.",
        reserved: "Vunnet, Tapt og Utsatt er status, ikke stadier.",
        duplicate: "To stadier kan ikke ha samme navn.",
        range:
          "Sannsynlighet er 0–100 %, og virkedager kan ikke være negative.",
        fields: {
          contact: "Kontaktperson",
          company: "Kunde",
          source: "Kilde",
          service: "Tjeneste",
          budget: "Budsjett",
          value: "Verdi",
          next_step: "Neste steg",
          meeting_date: "Møtedato",
          offer_file: "Tilbudsfil",
          offer_valid_until: "Tilbud gyldig til",
        },
        types: {
          call: "Ring",
          meeting: "Møte",
          site_visit: "Befaring",
          email: "E-post",
          task: "Oppgave",
        },
      },
    },
  },
  resources: {
    deals: {
      fields: {
        status: "Status",
        one_time_value: "Engangsverdi",
        monthly_value: "Månedlig verdi",
        annual_value: "Årsverdi",
        probability: "Sannsynlighet (%)",
        won_date: "Vunnet dato",
        lost_date: "Tapt dato",
      },
    },
  },
};

export const englishPipelineMessages = {
  crm: {
    deals: {
      probability_help: "Percent. Empty uses the stage's.",
      probability_overridden: "overridden",
      probability_range: "Probability must be between 0 and 100",
      status: {
        open: "Open",
        won: "Won",
        lost: "Lost",
        disqualified: "Disqualified",
        tabs: "Status",
        tab_open: "Open",
        tab_won: "Won",
        tab_lost: "Lost",
        empty_open: "No open opportunities.",
        empty_won: "No won opportunities yet.",
        empty_lost: "No lost opportunities.",
        from_stage: "from %{stage}",
        mark_won: "Mark as won",
        mark_lost: "Mark as lost",
        won_action: "Won",
        lost_action: "Lost",
        reopen: "Reopen",
        won_done: "%{name} is marked as won",
        lost_done: "%{name} is marked as lost",
        reopened: "%{name} is reopened",
      },
    },
    settings: {
      pipeline: {
        title: "Pipeline",
        help: "The stages an open opportunity moves through. Won, Lost and Disqualified are statuses, not stages. Probability is used for the weighted pipeline value, and rotting says how many working days without activity before an opportunity counts as rotting.",
        label: "Name",
        probability: "Probability (%)",
        rot: "Rots after (working days)",
        inbox: "Inbox for new leads",
        move_up: "Move up",
        move_down: "Move down",
        remove: "Remove stage",
        in_use: "Open opportunities are in this stage",
        required_fields: "Required before an opportunity moves here",
        next_step: "Suggested next step",
        next_step_type: "Type",
        offset: "Due (working days)",
        add: "Add stage",
        save: "Save stages",
        saved: "The stages are saved",
        save_error: "The stages could not be saved",
        need_one: "The pipeline needs at least one stage.",
        need_label: "Every stage needs a name.",
        reserved: "Won, Lost and Postponed are statuses, not stages.",
        duplicate: "Two stages cannot have the same name.",
        range: "Probability is 0–100 %, and working days cannot be negative.",
        fields: {
          contact: "Contact",
          company: "Customer",
          source: "Source",
          service: "Service",
          budget: "Budget",
          value: "Value",
          next_step: "Next step",
          meeting_date: "Meeting date",
          offer_file: "Proposal file",
          offer_valid_until: "Proposal valid until",
        },
        types: {
          call: "Call",
          meeting: "Meeting",
          site_visit: "Site visit",
          email: "Email",
          task: "Task",
        },
      },
    },
  },
  resources: {
    deals: {
      fields: {
        status: "Status",
        one_time_value: "One-time value",
        monthly_value: "Monthly value",
        annual_value: "Annual value",
        probability: "Probability (%)",
        won_date: "Won date",
        lost_date: "Lost date",
      },
    },
  },
};
